module.exports = __webpack_public_path__ + "img/3_0080.b5502f7.png";